import { compose, withState, withHandlers } from 'recompose'
import { checkActive, findActiveExpander } from './helpers'
import ExpanderGroup from './ExpanderGroup'
import position from 'components/common/hoc/position'
import toggle from 'components/common/hoc/toggle'

const withSetButtonActive = withState('buttonActive', 'setButtonActive', [])
const withExpanderHandlers = withHandlers({
  expanderHandler: ({
    setButtonActive,
    buttonActive,
    positionHandler,
    toggleHandlers,
    expanded
  }) => (index, children) => {
    setButtonActive(findActiveExpander(children, index, buttonActive))
    positionHandler(index)
    checkActive(expanded, buttonActive.findIndex(key => key === true), index) &&
    toggleHandlers.onClick()
  }
})

export default compose(
  position,
  toggle,
  withSetButtonActive,
  withExpanderHandlers
)(ExpanderGroup)
